import { FeedBackLevel } from '@chipinside/formbuilder'
import { MarkdownView } from '@chipinside/markdown'
import { Alert, AlertTitle, Box, styled } from '@mui/material'

import Colors from '#/styles/Colors'

const StyledBox = styled(Box)<{ level: FeedBackLevel }>(({ level }) => ({
  '& .wmde-markdown :is(h1, h2, h3, h4, h5, h6, p, strong, b, span)': {
    color: Colors.feedback[level]?.color,
  },
}))

export function FormBuilderMessage(props: any) {
  const level = props.variation ? props.variation : 'error'

  return props.value ? (
    <StyledBox level={level}>
      <Alert severity={level}>
        {props.label && <AlertTitle>{props.label}</AlertTitle>}
        <MarkdownView>{props.value}</MarkdownView>
      </Alert>
    </StyledBox>
  ) : null
}
